import { createSlice } from '@reduxjs/toolkit';

import { TAiDocument } from '@/types/documents';

interface IFormStateInitialState {
	applicationId: string;
	appHash: string;
	primaryOwnerId: string;
	documentIndexForUploading: number;
	isSkipFileUploadModalShown: boolean;
	isAtLeastOneDocumentUploaded: boolean;
	isAgreedPrefill: boolean;
	prefilledData: any;
	isSignatureValid: boolean;
	failedFiles: TAiDocument[];
}

const initialState: IFormStateInitialState = {
	applicationId: '',
	primaryOwnerId: '',
	appHash: '',
	isAtLeastOneDocumentUploaded: false,
	documentIndexForUploading: 0,
	isSkipFileUploadModalShown: false,
	isAgreedPrefill: false,
	isSignatureValid: false,
	failedFiles: [],
	prefilledData: {
		id: null,
		totalFunding: null,
		fundingPurposeType: null,
		fundingPurpose: null,
		ficoScoreType: null,
		annualRevenue: null,
		annualRevenueType: null,
		annualProfit: null,
		annualProfitType: null,
		targetBusinessOverview: {
			id: null,
			name: null,
			industryType: null,
			usaStateType: null,
			businessStartedAt: null,
			isStarted: true,
			isFranchise: true,
			hasGuarantors: true,
		},
		owners: [
			{
				id: null,
				firstName: null,
				lastName: null,
				email: null,
				phoneNumber: null,
				birthDate: null,
				businessWeight: null,
				isPrimary: true,
				address: {
					id: null,
					street: null,
					city: null,
					zipCode: null,
					usaStateType: null,
				},
				socialSecurityNumber: null,
				maritalStatusType: null,
			},
		],
		businessOverview: {
			id: null,
			name: null,
			isDBA: false,
			dbaName: null,
			phoneNumber: null,
			address: {
				id: null,
				street: null,
				city: null,
				zipCode: null,
				usaStateType: null,
			},
			businessStartedAt: null,
			businessEntityType: null,
			formationState: null,
			businessEIN: null,
			annualRevenue: null,
			annualProfit: null,
			businessActivityCode: null,
			legalAddress: {
				street: null,
				city: null,
				zipCode: null,
				usaStateType: null,
			},
		},
		businessTaxReturn: [],
		personalTaxReturn: [],
		governmentIdentity: [],
		isDraft: false,
	},
};

const formStateSlice = createSlice({
	name: 'formState',
	initialState,
	reducers: {
		setApplicationId: (state, action: { payload: string }) => {
			state.applicationId = action.payload;
		},
		setPrimaryOwnerId: (state, action: { payload: string }) => {
			state.primaryOwnerId = action.payload;
		},
		setAppHash: (state, action: { payload: string }) => {
			state.appHash = action.payload;
		},
		setIsAtLeastOneDocumentUploaded: (state, action: { payload: boolean }) => {
			state.isAtLeastOneDocumentUploaded = action.payload;
		},
		setDocumentIndexForUploading: (state, action: { payload: number }) => {
			state.documentIndexForUploading = action.payload;
		},
		setIsSkipFileUploadModalShown: (state, action: { payload: boolean }) => {
			state.isSkipFileUploadModalShown = action.payload;
		},
		setPrefilledData: (state, action: { payload: any }) => {
			state.prefilledData = action.payload;
		},
		setIsAgreedPrefill: (state, action: { payload: boolean }) => {
			state.isAgreedPrefill = action.payload;
		},
		setIsSignatureValid: (state, action: { payload: boolean }) => {
			state.isSignatureValid = action.payload;
		},
		setFailedFiles: (state, action: { payload: TAiDocument[] }) => {
			state.failedFiles = action.payload;
		},
	},
});

export const {
	setApplicationId,
	setIsAtLeastOneDocumentUploaded,
	setPrefilledData,
	setIsAgreedPrefill,
	setIsSignatureValid,
	setDocumentIndexForUploading,
	setIsSkipFileUploadModalShown,
	setFailedFiles,
	setPrimaryOwnerId,
	setAppHash,
} = formStateSlice.actions;
export default formStateSlice.reducer;
